module.exports = __webpack_public_path__ + "static/media/title_bg_4.86125337.svg";